import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap'
import Label from "components/general/Label"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { ALL_URL, isParalympic, splitArrayIntoFourColumns } from "helpers/utils";
import { TYPE_DATA, sortDataByField } from "helpers/utils";
import { FilterEventTypes, createEventData, pagesWithDisciplineFilter, publishFilterEvent } from 'components/common/ocs-custom-events/filterEvents';

//Sport Pictos Sprites SpritePictosSmall for the old ones and SpritePictosBig for the new big ones (Paris2024) 

//import SpritesPictos from "styles/OG2024/images/SpritePictosSmall.svg";
import SpritesPictos from "styles/OG2024/images/SpritePictosBig.svg";
//import SpritesPictos_Para from "styles/PG2024/images/SpritePictosSmall.svg";
import SpritesPictos_Para from "styles/PG2024/images/SpritePictosBig.svg";

export default function SelectorDisciplineCombo({ data, page, displayAllDisc = true }) {
    const [textCombo, setTextCombo] = useState();
    let params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page);
    //copy parameters URL to change 
    let paramsURL = { ...params }

    // reset to avoid orphan params when discipline changes
    paramsURL["mirs_event"] = "";
    if (page === 'records') {
        paramsURL["mirs_event"] = "";
        paramsURL["mirs_noc"] = "";
    }

    const sports = data?.filter(item => item?.isSport && item?.scheduled);
    if (sports?.some(disc => disc?.descriptionOrder && disc?.descriptionOrder !== 0)) {
        sortDataByField(sports, 'descriptionOrder', true, TYPE_DATA.NUMBER)
    } else {
        sortDataByField(sports, 'description', true, TYPE_DATA.STRING)
    }

    // sortDataByField(sports, "description", true, TYPE_DATA.STRING);
    const options = sports?.map((item, index) => {
        return (
            <Dropdown.Item key={"Selector-Discipline-" + item.code} eventKey={item.code} >
                <ItemDiscipline code={item.code} description={item.description} />
            </Dropdown.Item>
        )
    })

    useEffect(() => {
        let lbl = data?.find(item => item.code === paramsURL["mirs_discipline"])?.description
        if (lbl === undefined) {
            lbl = <Label data={'LabelAllDisciplines'} />;
            paramsURL["mirs_discipline"] = 'all-disc'
            setParamsUrl(paramsURL);
            // setShouldNavigate(true); //made stranger behavior in athletes/all-disc/{noc}
        }
        setTextCombo(lbl);

    }, [paramsURL["mirs_discipline"], data]);

    //Go to schedule 
    const handleOnChange = (key) => {
        paramsURL["mirs_discipline"] = key;
        if (page === 'schedulebynoc') {
            paramsURL["mirs_date"] = "";
        }
        if (pagesWithDisciplineFilter.includes(page)) {
            const payload = createEventData(FilterEventTypes.DISCIPLINE, key);
            publishFilterEvent(payload);
        }
        setParamsUrl(paramsURL);
        setShouldNavigate(true);
    };

    let allData

    // remove all disciplines option when in schedule page and all-days is selected;
    const isScheduleAndAllDays = () => {
        return page === 'schedule' && (!paramsURL["mirs_date"] || paramsURL["mirs_date"] === ALL_URL.ALL_DAYS);
    }

    if ((displayAllDisc) && !isScheduleAndAllDays()) {
        // if ((!['records', 'sportentries', 'reports', 'entries', 'entriesBySportsAndNoc'].includes(page)) && !isScheduleAndAllDays()) {
        allData = <Dropdown.Item key={ALL_URL.ALL_DISC} eventKey={ALL_URL.ALL_DISC} >
            <Label data={'LabelAllDisciplines'} />
        </Dropdown.Item>
    }
    const allItems = [...(allData ? [allData] : []), ...(options ? options : [])];
    const arrayOfColumns = splitArrayIntoFourColumns(allItems);

    return (
        <Dropdown onSelect={handleOnChange} className={"selectorContainer dropdownWithGrid"} >
            <Dropdown.Toggle as={CustomToggle} variant="success"  >
                {textCombo}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {arrayOfColumns}
            </Dropdown.Menu>
        </Dropdown>
    );
};


const ItemDiscipline = (props) => {
    const { mirs_competition } = useUrlFriendlyToParameters()
    //let competition = mirs_competition;
    const [showImage, setShowImage] = useState(true);
    const hideImg = (event) => {
        // this.setState({ showImg: false });
        setShowImage(false);
    };

    let Sprites

    if (isParalympic(mirs_competition)) {
        Sprites = SpritesPictos_Para;
    } else {
        Sprites = SpritesPictos;
    }


    return (
        <div className="itemDiscipline justify-content-left">
            <div className="sport-icon">
                {showImage ? (
                    <>
                        <svg role="img" className='sport-icon' aria-hidden="true" focusable="false"> <title>{props.code}</title><use xlinkHref={`${Sprites}#${props.code}`} /></svg>
                        {/*    <div className={props.code} alt={props.description}></div>*/}
                    </>
                ) : (
                    props.code
                )}
            </div>
            {props.description}
            {/*{props.code && <> - {props.code}</>}*/}
        </div>
    )
};

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (

    <Dropdown.Toggle variant="success" id="selectorDiscipline"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}

    >
        {children}
    </Dropdown.Toggle>

));